// extracted by mini-css-extract-plugin
module.exports = {"tablePaymentScheduleDetail":"BillingDocuments_tablePaymentScheduleDetail__2osXi"};